import React, { Component } from 'react';
import './tabs.css';
import { setTab } from '../../redux/actionCreators';
import { connect } from "react-redux";

class Tab extends Component {
  constructor(props) {
    super(props);
  }

  handleTabClick = (index) => {
    this.props.setTab(index);
  };

  render() {
    const { tabs } = this.props;
    const  activeTab  = this.props.tab;
    const activeTabContent = tabs[activeTab];
    if (!activeTabContent) {
      return <div>Problema al cargar la página</div>;
    }
  
    return (
      <div>
        <div className="tabs">
          {tabs.map((tab, index) => (
            <div
              key={index}
              className={index === activeTab ? 'tab active' : 'tab'}
              onClick={() => this.handleTabClick(index)}
            >
              {tab.title}
            </div>
          ))}
        </div>
        <div className="tab-content">
          {activeTabContent.content}
        </div>
      </div>
    );
  }
}


const mapStateToProps = state => {
  return {
      tab: state.tab
  };
};

const mapDispatchToProps = dispatch => {
  return {
      setTab: tab => {
          dispatch(setTab(tab));
      }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Tab);